module.exports = __webpack_public_path__ + "static/2-18988c8873a4e88609e866da0580ad12.png";